import { render, staticRenderFns } from "./AppRules.vue?vue&type=template&id=5fae7578&scoped=true&"
import script from "./AppRules.vue?vue&type=script&lang=js&"
export * from "./AppRules.vue?vue&type=script&lang=js&"
import style0 from "./AppRules.vue?vue&type=style&index=0&id=5fae7578&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae7578",
  null
  
)

export default component.exports